import React from 'react';

const Icon = ({
  name,
  fill = 0,
  weight = 400,
  grade = 0,
  opticalSize = 24,
  size = 24,
  color = '#2d2d2d',
  className = '',
  style = {},
  ...rest
}) => (
  <span
    className={ `icon material-symbols-outlined ${className}` }
    style={ {
      fontSize: size,
      color,
      fontVariationSettings: `"FILL" ${fill}, "wght" ${weight}, "GRAD" ${grade}, "opsz" ${opticalSize}`,
      ...style,
    } }
    { ...rest }
  >
    { name }
  </span>
);

export default Icon;